import React from "react";

export const EntryFeeTypeColumnFormatter = (cellContent, row, rowIndex, dIndexName) => (
  cellContent == undefined || 
  cellContent == "NA"||
  cellContent == ""||
  cellContent == null

  
  ? "-" : cellContent[0].inCurrency.label
  
);